<template>
  <div class="role-dialog">
    <el-dialog
        title="请选择机构/角色"
        :visible.sync="innerVisible"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :show-close="showCloseVisible"
        @closed="handleClose"
    >
      <div class="login-role">
        当前登录角色: <span class="role-name">{{ deptRoleName || '暂无' }}</span>
      </div>
      <el-form ref="form" :model="form" label-position="top" :rules="rules"  label-width="80px" v-if="statusOptions.length > 0">
        <el-form-item label="" prop="value">
          <div class="slot-content">
            <div class="content-item" v-for="(item, index) in statusOptions" :key="index">
              <div
                  :class="['role-item', { selected: form.value === item.dictValue }]"
                  @click="selectRole(item)"
              >
                {{ item.dictLabel }}
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

  </div>


</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "selRoleLogin",
  props: {
    switchMode: {
      type: String,
      default: "",
    },
    open: {
      type: Boolean,
      default: true,
    },

  },
  computed: {
    ...mapGetters(["deptRoleName", "roleList", "roleId", "deptId"]),
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        this.initSelectRole()
      }
    },
    innerVisible(val) {
      if (!val) {
        this.$emit('update:open', false);
      }
    }
  },
  data() {
    return {
      innerVisible: false,  // 添加这行
      showCloseVisible: false,
      form: {
        value: ''
      },
      statusOptions: [],
      rules: {
        value: [
          {
            required: true,
            message: "请选择要登陆的角色",
            trigger: "blur",
          },
        ],
      },
      selectRoleName: ''
    }
  },
  created() {},
  mounted() {
    if (this.switchMode){
      this.showCloseVisible=true
      this.statusOptions=this.roleList.flatMap(role => {
        return {
            dictValue: role.value,
            dictLabel: role.deptName + "-" +role.name
          };
      });
    }else{
      this.statusOptions=this.roleList.flatMap(role => {
        return {
            dictValue: role.value,
            dictLabel: role.deptName + "-" +role.name
          };

      });
    }
  },
  methods:{

    /**
     * 初始化当前角色，默认勾选当前登录角色
     */
    initSelectRole() {
      this.form.value = this.deptId + ',' + this.roleId
    },
    handleClose() {
      this.$emit('update:open', false);
      this.$emit('roleLoginClose');

    },
    selectRole(item) {
      this.form.value = item.dictValue;
      this.selectRoleName = item.dictLabel;
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {

          let reloginDeptId = ''
          let reloginRoleId=''
          if (String(this.form.value).includes(',')) {
            // 如果包含逗号，分割字符串
            let parts = this.form.value.split(',');
            reloginDeptId = parts[0].trim();
            reloginRoleId = parts[1].trim();
          } else {
            // 如果没有逗号，直接赋值给 reloginRoleId
            reloginDeptId = '';
            reloginRoleId = this.form.value;
          }
          let params = {
            relogin:'relogin',
            reloginDeptId:reloginDeptId,
            reloginRoleId:reloginRoleId,
          };
            this.$store
                .dispatch("reLogin", params)
                .then(() => {
                  if(this.selectRoleName !== null) {
                    sessionStorage.setItem('loginRoleId', reloginRoleId)
                    sessionStorage.setItem('loginDeptId', reloginDeptId)
                    sessionStorage.setItem('lastLoginRecord', JSON.parse(sessionStorage.getItem('user')) + '_' + reloginDeptId + '_' + reloginRoleId)
                  } 
                  this.selectRoleName = null;
                  this.$store.dispatch('getWxCode');
                  if (this.$route.name === 'sel') {
                    this.$router.push({ path: "/home" }).catch(() => {});
                  }else {
                    location.reload();
                  }
                  this.showCloseVisible=false
                  if (this.switchMode){
                    this.showCloseVisible=true
                    this.$emit("roleLoginClose");
                    window.location.reload()
                  }
                })
                .catch(() => {});
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.role-dialog {
  .el-dialog__body {
    padding: 0;
  }
}
.slot-content {
  padding: 0 25px;
  max-height: 300px;
  overflow-y: auto;
}

.role-item {
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #F3F8FF;
  background-color: #F3F8FF;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.role-item:hover {
  background-color: #e5f2ff;
}

.role-item.selected {
  background-color: #076BF2;
  color: white;
  font-weight: bold;
  border: 1px solid #076BF2;
}

.login-role {
  font-size: 16px;
  padding: 0 25px 25px 25px;
  color: #333;
}
.role-name {
  font-weight: bold;
  color: #007bff;
}
</style>